import { BELGIAN_POSTAL_CODES } from "@/data/belgian-postal-codes";

export function getCityFromPostalCode(code: string): string | null {
  const val = (code || "").trim();
  if (val.length === 4 && BELGIAN_POSTAL_CODES[val]) {
    return BELGIAN_POSTAL_CODES[val];
  }
  return null;
}

export function getRegionFromPostalCode(code: string): string | null {
  const num = parseInt(code, 10);
  if (isNaN(num)) return null;
  if (num >= 1000 && num <= 1299) return "bruxelles";
  if (num >= 1500 && num <= 1999) return "flandre";
  if (num >= 2000 && num <= 2999) return "flandre";
  if (num >= 3000 && num <= 3999) return "flandre";
  if (num >= 8000 && num <= 8999) return "flandre";
  if (num >= 9000 && num <= 9999) return "flandre";
  if (num >= 1300 && num <= 1499) return "wallonie";
  if (num >= 4000 && num <= 7999) return "wallonie";
  return null;
}

/**
 * Reverse lookup : returns the smallest postal code that maps to the given
 * commune (case-insensitive). Many communes span several postal codes
 * (ex. Bruxelles = 1000 / 1005 / 1006 / …) — we pick the smallest as a
 * sensible default that the user can still tweak manually afterwards.
 */
export function getPostalCodeFromCity(city: string): string | null {
  const normalized = (city || "").trim().toLowerCase();
  if (!normalized) return null;
  let best: string | null = null;
  for (const [code, value] of Object.entries(BELGIAN_POSTAL_CODES)) {
    if (value.toLowerCase() === normalized) {
      if (!best || code < best) best = code;
    }
  }
  return best;
}
